var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleLayout',[_c('single')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }